import { FormMAsterService } from './../../../formsMaster/services/formMaster.service';
import { PagingService } from '../../../../shared/Services/PagingService';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { BaseComponent } from '../../../../shared/Components/base/base.component';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'formsmastervalues-get',
  templateUrl: './get.component.html',
  styleUrls: ['./get.component.scss'],
})
export class GetFormMasterFieldsValuesComponent extends BaseComponent implements OnInit {
  fields: [] = [];
  @Input() refId: number = 0;
  @Input() formId: number;
  @Input() refDataType: string;
  constructor(
    public route: Router,
    public service: FormMAsterService,
    public paging: PagingService,
    private aRoute: ActivatedRoute
  ) {
    super(route, service, paging);
  }

  ngOnInit() {
    this.service.post({ DataRefId: this.refId, FormId: this.formId , DataRefType : this.refDataType}, '/GetForm').subscribe((res) => {
      this.fields = res[0].fields;

      this.finishLoading = true;
      //  this.modalRef.hide();
      //  this.toastr.success('تم ارسال طلب الخدمة بنجاح', 'ارسال طلب');
      // this.toast.success('Submit Data Successfully', 'sucess', {
      //   duration: 4000,
      // });
    });
    // this.service.getById(this.formId).subscribe(res => {
    //   this.fields = res;
    //   this.finishLoading = true;
    //   console.log(res);
    // });
    //   this.loadEntities();
  }

  save() {
    this.service.post({ DataRefId: this.refId }, '/GetForm').subscribe((res) => {
     
      //  this.toastr.success('تم ارسال طلب الخدمة بنجاح', 'ارسال طلب');
      // this.toast.success('Submit Data Successfully', 'sucess', {
      //   duration: 4000,
      // });
    });
  }
}
